(function () {
  var COOKIE_KEY = 'lien_exit_popup_shown';
  var COOKIE_DAYS = 7;

  // localStorage + çerez birlikte: önizleme çerçeve içinde çalıştığı için
  // SameSite'sız çerez reddedilebiliyor; localStorage her koşulda tutuyor.
  function isDismissed() {
    try { if (localStorage.getItem(COOKIE_KEY)) return true; } catch (e) {}
    return !!document.cookie.match(new RegExp('(^| )' + COOKIE_KEY + '=([^;]+)'));
  }

  function markDismissed() {
    try { localStorage.setItem(COOKIE_KEY, String(Date.now())); } catch (e) {}
    var d = new Date();
    d.setTime(d.getTime() + (COOKIE_DAYS * 24 * 60 * 60 * 1000));
    document.cookie = COOKIE_KEY + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function openPopup() {
    var popup = document.getElementById('lien-exit-popup');
    if (!popup) return;
    popup.classList.add('is-open');
    popup.removeAttribute('aria-hidden');
    markDismissed();
  }

  function closePopup() {
    var popup = document.getElementById('lien-exit-popup');
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    markDismissed();          // X'e basınca da hatırla
  }

  function init() {
    if (isDismissed()) return;

    var popup = document.getElementById('lien-exit-popup');
    if (!popup) return;

    // Desktop: mouseleave event
    document.addEventListener('mouseleave', function handler(e) {
      if (e.clientY <= 0) {
        openPopup();
        document.removeEventListener('mouseleave', handler);
      }
    });

    // Mobil: sayfanın %60'ı kaydırıldığında (gerçek ilgi sinyali).
    // ÖNEMLİ: tek dinleyici. Önceki sürümde resetTimer her kaydırmada
    // YENİ bir scroll dinleyicisi ekliyordu; popup kapatılsa bile bir
    // sonraki kaydırmada tekrar açılıyordu.
    function onScrollIntent() {
      if (isDismissed()) { window.removeEventListener('scroll', onScrollIntent); return; }
      var seen = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
      if (seen >= 0.6) {
        window.removeEventListener('scroll', onScrollIntent);
        openPopup();
      }
    }
    window.addEventListener('scroll', onScrollIntent, { passive: true });

    // Kapatma
    popup.querySelector('.lien-popup__close')?.addEventListener('click', closePopup);
    popup.querySelector('.lien-popup__overlay')?.addEventListener('click', closePopup);

    // Form submit — submit to Shopify customer form, show inline success
    document.getElementById('lien-popup-form')?.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = this;
      var btn = form.querySelector('.lien-popup__btn');
      var email = form.querySelector('input[type="email"]')?.value;
      if (!email) return;
      if (btn) { btn.classList.add('lien-popup__btn--loading'); btn.textContent = 'Gönderiliyor…'; }
      var fd = new FormData(form);
      fetch('/contact#contact_form', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      }).catch(function () { /* network error — still show success UX since Shopify retries server-side */ })
        .finally(function () {
          var success = document.querySelector('.lien-popup__success');
          if (success) success.hidden = false;
          form.style.display = 'none';
          if (window.dataLayer) {
            window.dataLayer.push({ event: 'newsletter_signup', source: 'exit_popup', email: email });
          }
          setTimeout(closePopup, 3500);
        });
    });

    // ESC tuşu
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
